import { packingTemplateIdFormat } from "@redotech/redo-fulfillment-id";
import { inboundShipmentProductIdFormat } from "@redotech/redo-inventory-id";
import { PackingModeSchema } from "@redotech/redo-model/inventory/packing-mode";
import * as z from "zod";

export const updateShipmentProductPacking = {
  name: "updateShipmentProductPacking" as const,
  input: z.object({
    inboundShipmentProductId: inboundShipmentProductIdFormat.schema,
    packingMode: PackingModeSchema,
    packingTemplateId: packingTemplateIdFormat.schema.nullish(),
  }),
  output: z.object({ success: z.boolean() }),
};
